import { render } from "./RelatorioAtendEstrela.vue?vue&type=template&id=8a70993e"
import script from "./RelatorioAtendEstrela.vue?vue&type=script&lang=js"
export * from "./RelatorioAtendEstrela.vue?vue&type=script&lang=js"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__